import { render, staticRenderFns } from "./ItemsWrapper.vue?vue&type=template&id=00e34726&scoped=true"
import script from "./ItemsWrapper.vue?vue&type=script&lang=js"
export * from "./ItemsWrapper.vue?vue&type=script&lang=js"
import style0 from "./ItemsWrapper.vue?vue&type=style&index=0&id=00e34726&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e34726",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e34726')) {
      api.createRecord('00e34726', component.options)
    } else {
      api.reload('00e34726', component.options)
    }
    module.hot.accept("./ItemsWrapper.vue?vue&type=template&id=00e34726&scoped=true", function () {
      api.rerender('00e34726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ItemsWrapper.vue"
export default component.exports